package uz.ferro.erp.feature.home.ui

import kotlinx.coroutines.MainScope
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import mui.icons.material.Menu
import mui.material.Alert
import mui.material.AlertColor
import mui.material.AlertTitle
import mui.material.Box
import mui.material.Divider
import mui.material.IconButton
import mui.material.IconButtonEdge
import mui.material.Snackbar
import mui.material.SnackbarCloseReason
import mui.material.SnackbarOrigin
import mui.material.SnackbarOriginHorizontal
import mui.material.SnackbarOriginVertical
import mui.material.Toolbar
import mui.material.Typography
import mui.material.styles.TypographyVariant
import mui.system.sx
import react.FC
import react.dom.html.ReactHTML
import react.router.Outlet
import react.router.useLocation
import react.useContext
import react.useEffect
import react.useEffectOnce
import react.useState
import uz.ferro.erp.Colors
import uz.ferro.erp.NavigationContext
import uz.ferro.erp.feature.alert.AlertManager
import uz.ferro.erp.feature.alert.AlertManagerContext
import uz.ferro.erp.feature.alert.AlertManagerHost
import uz.ferro.erp.feature.alert.AlertMessage
import uz.ferro.erp.feature.alert.AlertType
import uz.ferro.erp.feature.menu.model.MenuItem
import uz.ferro.erp.feature.menu.ui.ToolbarMenuItem
import uz.ferro.erp.manager.AuthManager.canUseHomeDashboard
import uz.ferro.erp.ui.HorizontalLayout
import uz.ferro.erp.ui.VerticalLayout
import web.cssom.AlignItems
import web.cssom.Overflow
import web.cssom.number
import web.cssom.pct
import web.cssom.px

val HomeDashboard = FC {
    val navigator = useContext(NavigationContext)

    if (canUseHomeDashboard()) {
        var alertMessage by useState<AlertMessage>()

        val alertManagerHost = object : AlertManagerHost {
            override fun onSuccessMessage(message: String) {
                alertMessage = AlertMessage(
                    type = AlertType.SUCCESS,
                    message = message
                )
            }

            override fun onErrorMessage(message: String) {
                alertMessage = AlertMessage(
                    type = AlertType.ERROR,
                    message = message
                )
            }
        }
        val alertManager = AlertManager(alertManagerHost)

        AlertManagerContext(alertManager) {
            HomeDashboardContent()

            Snackbar {
                open = alertMessage != null
                autoHideDuration = 5000
                anchorOrigin = object : SnackbarOrigin {
                    override var vertical: SnackbarOriginVertical = SnackbarOriginVertical.top
                    override var horizontal: SnackbarOriginHorizontal = SnackbarOriginHorizontal.right
                }
                onClose = { event, reason ->
                    if (reason != SnackbarCloseReason.clickaway) {
                        alertMessage = null
                    }
                }

                Alert {
                    severity = when (alertMessage?.type) {
                        AlertType.SUCCESS -> AlertColor.success.toString()
                        AlertType.ERROR -> AlertColor.error.toString()
                        else -> AlertColor.error.toString()
                    }

                    sx {
                        width = 100.pct
                    }
                    AlertTitle {
                        when (alertMessage?.type) {
                            AlertType.ERROR -> +"Xatolik"
                            else -> +""
                        }
                    }

                    onClose = { _ ->
                        alertMessage = null
                    }
                    +alertMessage?.message.orEmpty()
                }
            }
        }
    } else {
        MainScope().launch {
            delay(100) // Workaround for avoid blank page
            navigator.openLogin()
        }
    }
}

val HomeDashboardContent = FC {
    val navigator = useContext(NavigationContext)
    var drawerOpen by useState(false)
    var toolbarTitle by useState("")
    var toolbarMenuItems by useState<List<MenuItem>>(emptyList())
    val location = useLocation()
    val currentPath = location.pathname
    val pageMenus by useState<MutableMap<String, List<MenuItem>>>(mutableMapOf())

    useEffect(currentPath) {
        if (currentPath == "/board") {
            toolbarTitle = "Ferro CRM"
        }

        val key = pageMenus.keys.firstOrNull { currentPath.endsWith(it) }
        toolbarMenuItems = if (key == null) {
            emptyList()
        } else {
            pageMenus[key].orEmpty()
        }
    }

    val dashboardUI = object : DashboardUI {
        override fun setTitle(title: String) {
            toolbarTitle = title
        }

        override fun setMenuItems(page: String, items: List<MenuItem>) {
            toolbarMenuItems = items
            pageMenus[page] = items
        }
    }

    useEffectOnce {
        MainScope().launch {
            try {
//                AuthManager.checkAuthorization()
            } catch (e: Exception) {
                // no-op
            }
        }
    }

    HorizontalLayout {
        sx {
            height = 100.pct
            width = 100.pct
            alignItems = AlignItems.stretch
            backgroundColor = Colors.secondaryBackground
        }

        VerticalLayout {
            sx {
                if (drawerOpen) {
                    width = 240.px
                    flexShrink = number(0.0)
                } else {
                    width = 64.px
                    flexShrink = number(0.0)
                }

                overflowX = Overflow.hidden
                backgroundColor = Colors.drawerColor
                color = Colors.white
            }

            Box {
                sx {
                    height = 64.px
                }
            }

            Divider()

            HomeDrawerMenu {
                isCompactMode = drawerOpen.not()
            }
        }

        VerticalLayout {
            sx {
                flexShrink = number(0.0)
                flexGrow = number(1.0)
                alignItems = AlignItems.stretch
            }

            Box {
                Toolbar {
                    sx {
                        backgroundColor = Colors.accentColor
                    }
                    IconButton {
                        onClick = {
                            drawerOpen = drawerOpen.not()
                        }
                        edge = IconButtonEdge.start

                        sx {
                            marginRight = 5.px
                        }

                        Menu {
                            sx {
                                color = Colors.accentContrastColor
                            }
                        }
                    }

                    Typography {
                        variant = TypographyVariant.h6
                        noWrap = true
                        component = ReactHTML.div
                        sx {
                            color = Colors.white
                            flexGrow = number(1.0)
                        }
                        +toolbarTitle
                    }

                    HorizontalLayout {
                        space = 16.px
                        toolbarMenuItems.forEach { menuItem->
                            ToolbarMenuItem {
                                item = menuItem
                            }
                        }
                    }
                }
            }

            VerticalLayout {
                sx {
                    width = 100.pct
                    flexGrow = number(1.0)
                }

                Outlet {
                    context = dashboardUI
                }
            }
        }
    }
}